import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../img/DeepBlue.png'


const _hoisted_1 = { class: "work" }
const _hoisted_2 = {
  class: "module",
  id: "deepblue"
}
const _hoisted_3 = { id: "work-beginnerTemplate" }
const _hoisted_4 = { id: "companyInformation_combo" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "DeepBlue",
  id: "deepblue"
}, null, -1)
const _hoisted_6 = { id: "nameAndAddress" }
const _hoisted_7 = {
  href: "https://en.deepblueai.com",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_8 = { class: "collapse" }
const _hoisted_9 = { id: "title" }
const _hoisted_10 = { id: "title" }
const _hoisted_11 = { id: "red-text" }
const _hoisted_12 = { id: "red-text" }
const _hoisted_13 = { id: "red-text" }
const _hoisted_14 = { id: "title" }

import { ref } from 'vue'
import '../css/WorksViewCss.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'WorksView',
  setup(__props) {

const activeNames = ref(['0'])


return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('WorksView.deepblueTitle')), 1),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('WorksView.deepblueDate')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h4", null, [
              _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('WorksView.deepblueCompany')), 1)
            ]),
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('WorksView.deepblueLocation')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_collapse, {
          modelValue: activeNames.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNames).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, { name: "1" }, {
              title: _withCtx(() => [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('WorksView.projectDescriptionTitle')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('WorksView.projectDescriptionText')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.detectingEmergencies')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.detectingEmergenciesText')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.detectingTrash')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.detectingTrashText')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.detectingVandalism')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.detectingVandalismText')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.detectingSmoking')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.detectingSmokingText')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.detectingVehicles')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.detectingVehiclesText')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.detectingObstruction')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.detectingObstructionText')), 1)
                  ])
                ]),
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('WorksView.popularFeaturesTitle')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.emergencyDetection')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.emergencyDetectionText')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.ropeMonitoring')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.ropeMonitoringText')), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.trashMonitoring')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.trashMonitoringText')), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, { name: "2" }, {
              title: _withCtx(() => [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('WorksView.responsibilitiesTitle')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.algorithmTesting')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.algorithmTestingText')) + " ", 1),
                      _createElementVNode("strong", _hoisted_11, _toDisplayString(_ctx.$t('WorksView.algorithmTestingHighlight')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.algorithmTestingText2')), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.algorithmValidation')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.algorithmValidationText')) + " ", 1),
                      _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.$t('WorksView.algorithmValidationHighlight')), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.technicalMonitoring')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.technicalMonitoringText')) + " ", 1),
                      _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.$t('WorksView.technicalMonitoringHighlight')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.technicalMonitoringText2')), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.dataProcessing')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.dataProcessingText')), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.storageManagement')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.storageManagementText')), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.networkConnection')), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('WorksView.networkConnectionText')), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, { name: "3" }, {
              title: _withCtx(() => [
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('WorksView.technologyStackToolsTitle')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.technologyStack')), 1),
                    _createTextVNode("C, Python, Shell, Linux ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('WorksView.tools')), 1),
                    _createTextVNode("Ubuntu, Docker, Conda, Jira, Git, VoTT ")
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})